mutation SetAssetExpectedReturn(
  $assignmentId: ID!
  $expectedReturnMethod: AssetReturnMethodEnum!
) {
  setAssetExpectedReturn(
    input: {
      assignmentId: $assignmentId
      expectedReturnMethod: $expectedReturnMethod
    }
  ) {
    item {
      id
      expectedReturnMethod
      stage
    }
  }
}
